import { TextField as MuiTextField, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import { useAppContext } from '../../contexts/AppContext';
import { useState } from 'react';
import useDebouncedCallback from '../../hooks/useDebouncedCallback';

const MonthlyValuesField = ({ field }: { field: any }) => {
  const { getFormDataItem, updateFormValue } = useFormContext();
  const formData = useFormData();
  const { setModified } = useAppContext();
  const [inputValues, setInputValues] = useState<{ [key: number]: any }>({});

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const currentValues = getFormDataItem(formData, field.name) || Array(12).fill(0);

  const debouncedHandleChange = useDebouncedCallback((fieldName: string, newValues: any[]) => {
    updateFormValue(fieldName, newValues);
    setModified(true);
  }, 2000);

  const handleMonthChange = (index: number, value: string) => {
    setInputValues((prev) => ({ ...prev, [index]: value }));

    const newValues = [...currentValues];
    newValues[index] = value === '' ? null : Number(value);
    updateFormValue(field.name, newValues);

    debouncedHandleChange(field.name, newValues);
  };

  // Function to determine if the field is disabled
  const isDisabled = () => {
    if (!field.hasOwnProperty('disabled')) {
      return false;
    }

    const disabledValue = field.disabled;

    // For yield_evaluation.source, we want to enable the array only if source === 'monthly'
    if (disabledValue === 'yield_evaluation.source') {
      const source = getFormDataItem(formData, disabledValue);
      return source !== 'monthly';
    }

    // Existing logic for other cases
    return getFormDataItem(formData, disabledValue);
  };

  return (
    <Grid size={field.size || 12} key={field.name}>
      <Typography color="text.primary" variant={field.font_size || 'h6'} sx={{ mb: 2 }}>
        {field.label}
      </Typography>
      <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
        <Grid container spacing={2}>
          {months.map((month, index) => (
            <Grid size={3} key={month}>
              <MuiTextField
                label={month}
                fullWidth
                type="number"
                value={inputValues[index] !== undefined ? inputValues[index] : currentValues[index]}
                onChange={(e) => handleMonthChange(index, e.target.value)}
                disabled={isDisabled()}
                inputProps={{
                  step: 'any',
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
};

export default MonthlyValuesField;
